import {formatNumber} from '@angular/common';

/**
 * "1 company", "2 companies", "0 companies", "1,234 seats": the noun agrees with the number (ITP-E-146-03).
 * `many` defaults to `one + 's'`; a missing number counts as 0.
 */
export function countOf(n: number, one: string, many?: string): string {
  const value = n ?? 0;
  return `${formatNumber(value, 'en-US', '1.0-0')} ${value === 1 ? one : many ?? one + 's'}`;
}
